"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.closureShowHiddenMessageDefaultValue = exports.closureShowHiddenMessageSchema = void 0;
const zod_1 = require("zod");
exports.closureShowHiddenMessageSchema = zod_1.z.object({
    from_closure: zod_1.z.string(),
    message: zod_1.z.string(),
});
const defaultValue = {
    from_closure: '2021-01-01',
    message: 'Fechamento não liberado, aguarde a liberação',
};
exports.closureShowHiddenMessageDefaultValue = JSON.stringify(defaultValue, null, '\t');
